import { Timestamp } from 'firebase/firestore';

const WEEK_MS = 1000 * 60 * 60 * 24 * 7;
const DAY = ['일', '월', '화', '수', '목', '금', '토'];

export const isNew = (createdMS: number = WEEK_MS) => {
  const now = Date.now();
  const created = createdMS;
  return now - created < WEEK_MS;
};

export const koreanDay = (day: number) => DAY[day];
export const margin = (text: number | string, m: number) => {
  if (`${text}`.length < m) {
    return `${'0'.repeat(m - `${text}`.length)}${text}`;
  }
  return `${text}`;
};

export const toFormat = (date: Date, showTime = false) =>
  `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()} (${koreanDay(
    date.getDay()
  )})${
    showTime
      ? ` ${margin(date.getHours(), 2)}:${margin(date.getMinutes(), 2)}`
      : ''
  }`;

export const toDateFormat = (timestamp: Timestamp, showTime = false) => {
  const date = timestamp.toDate();
  return toFormat(date, showTime);
};

export const toTimestamp = (date: Date) => {
  return Timestamp.fromDate(date);
};
